// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9OO6s","text":"styles_text__lwYYW","icon":"styles_icon__U0P7R","open":"styles_open__Mxbx-","activeLink":"styles_activeLink__9NeaL"};